import Vue from 'vue'

console.log('process env node_env', process.env.NODE_ENV)
if (process.env.NODE_ENV === 'production') {
  // Check if a specific, non-standard environment variable is set
  // For example, if you set VUE_APP_DISABLE_LOGS=true in a .env.development file
  // if (process.env.VUE_APP_DISABLE_LOGS === 'true') {
  console.log = function() {};
  console.warn = function() {};
  console.info = function() {};
    // You might want to keep console.error() for visible errors
    // console.error = function() {}; 
  // }
}

console.log('test after disable')


import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'

import AsyncComputed from 'vue-async-computed'
import VModal from 'vue-js-modal'
import router from './routes/router'
import VueGtag from 'vue-gtag'
// import Router from 'vue-router'
// import RouterTab from 'vue-router-tab'
// import 'vue-router-tab/dist/lib/vue-router-tab.css'
// import router from './router'
// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'

Vue.use(VModal)
Vue.use(AsyncComputed)
// Vue.use(RouterTab)
Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: 'G-LW1QZLMNT4' }, // Replace with your GA4 Measurement ID
  // Optional: Pass the router instance for automatic page view tracking
  // vueRouter: router,
  // Optional: Prevent initial page view from being sent twice if using router
  params: { send_page_view: false }
});

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
